module.exports = __webpack_public_path__ + "img/xltm-icon.44930832.svg";